import React from 'react';
import Skeleton from '@mui/material/Skeleton';

function CaptureSkeleton() {
  return (
    <div className="capture-loading" role="status" aria-label="Loading activity captures">
      <Skeleton animation="wave" width={120} height={24} />
      <div className="small-snapshot-grid snapshot-grid" aria-hidden="true">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={index} className="snapshot capture-skeleton-card">
            <Skeleton animation="wave" variant="rectangular" className="capture-image-skeleton" />
            <div className="snapshot-details">
              <Skeleton animation="wave" width="75%" />
              <Skeleton animation="wave" width="100%" height={12} />
              <Skeleton animation="wave" width="55%" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CaptureSkeleton;
